export const variants: Variant[] = [
  "contained",
  "outlined",
  "text",
  "transparent",
  "solid",
];

export const COLORS = {
  white: "#FFF",
  white20: "#FFF3",
  white30: "#FFFFFF4D",
  white40: "#FFF6",
  white60: "#FFF9",
  white70: "#FFFFFFB2",
  white80: "#FFFC",
};
